import { useSearchParams } from "react-router";
import { ScopeOfWork } from "../types/scope-of-work";

// The search parameter holding the id of the selected scope of work.
const scopeOfWorkParam = "scopeOfWork";

/**
 * useSelectedScopeOfWorkFromSearchParams keeps the scope of work selected
 * among scopeOfWorks in the "scopeOfWork" search parameter. selected is
 * the one the parameter names, falling back to the first, selectedId its
 * id. select sets the parameter, or clears it without an id, replacing
 * the history entry.
 *
 * Unlike the rest of services/, it depends on the router: the selection
 * must survive a reload and be part of a link, and the scope of works
 * pages of offers and contracts share it.
 */
export function useSelectedScopeOfWorkFromSearchParams(
  scopeOfWorks: ScopeOfWork[],
): {
  selectedId: string | undefined;
  select: (id?: string) => void;
  selected: ScopeOfWork | undefined;
} {
  const [searchParams, setSearchParams] = useSearchParams();

  const paramId = searchParams.get(scopeOfWorkParam);
  const selected =
    scopeOfWorks.find((sow) => sow.id === paramId) ?? scopeOfWorks[0];

  const select = (id?: string) =>
    setSearchParams(
      (params) => {
        if (id) {
          params.set(scopeOfWorkParam, id);
        } else {
          params.delete(scopeOfWorkParam);
        }
        return params;
      },
      { replace: true },
    );

  return { selectedId: selected?.id, select, selected };
}
